module.exports = __webpack_public_path__ + "img/banner1-en.3d89c1ae.png";